export const BANKING_GENERAL_DISCLOSURE_TEXT = `Fruitful is a financial technology company, not a bank. Deposit accounts provided by Emigrant Bank, Member FDIC. The Fruitful Card is issued by Emigrant Bank pursuant to license by Mastercard International Incorporated.`;

export const REWARDS_TC_URL = 'https://fruitful.com/legal/rewards-tc';
export const REWARDS_TC_LABEL =
    'Fruitful Card Rewards Program Terms and Conditions';

export const DEPOSIT_ACCOUNT_AGREEMENT_URL =
    'https://fruitful.com/legal/deposit-account-agreement';
export const DEPOSIT_ACCOUNT_AGREEMENT_LABEL =
    'Fruitful Deposit Account Agreement';

export const INVESTMENT_MANAGEMENT_AGREEMENT_URL =
    'https://fruitful.com/legal/im-agree';
export const INVESTMENT_MANAGEMENT_AGREEMENT_LABEL =
    'Fruitful Investment Management Agreement';

export const INVESTMENT_FRUITFUL_WHOLLY_OWNED =
    '“Fruitful” refers to Fruitful, Inc. and its wholly-owned, affiliated, and separately managed subsidiaries, Fruitful Financial, LLC and Fruitful Advisory, LLC, an SEC-registered investment adviser. All investing involves risk, including the risk of losing the money you invest, and past performance does not guarantee future performance. Additional disclosures can be referenced at fruitful.com.';

export const INVESTMENT_NOT_FDIC_INSURED =
    'Investment products and services provided by Fruitful Advisory, LLC are NOT FDIC INSURED, NOT BANK GUARANTEED, and MAY LOSE VALUE.';
